import { FotowebIntegration } from "./typescript/FotowebIntegrationV4";
import "./vendor/jquery-ui.custom";
import "./typescript/FotowebIntegrationV4";
import "./vendor/cropper.min.js";
import "../../wwwroot/ClientResources/Scripts/Editors/StreamlineIconsSelection/ImportSvgDefinitions";
import * as $ from "jquery";
window.$ = $;
window.fotowebIntegration = FotowebIntegration;
